export const namespacedPrefix = '[CLIENTS]';
